import React, { useContext, useEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import FadeIn from '../../../../components/Animation/FadeIn'
import Lottie from 'lottie-react'
import technologyP1Animation from '../../../../assets/animations/technology-part1.json'
import technologyP2Animation from '../../../../assets/animations/technology-part2.json'
import technologyMobileAnimation from '../../../../assets/animations/technology-mobile.json'
import { Waypoint } from 'react-waypoint'
import SectionWithTag from '../../../../components/SectionWithTag'
import { useIsMobile } from '../../../../utils/helpers'
import PaddingContext, { SetPaddingProps } from '../../../../utils/PaddingContext'
import Segments from './components/Segments'

const HowItWorks = ({ setPadding }: SetPaddingProps) => {
    const [play, setPlay] = useState(false)
    const lottieRef = useRef<any>(null)
    const ref = useRef<HTMLDivElement>(null)
    const [contentMargin, setContentMargin] = useState(200)
    const isMobile = useIsMobile()
    const animationStartRef = useRef<HTMLDivElement>(null)
    const titleRef = useRef<HTMLDivElement>(null)
    const descriptionRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)
    const { padding } = useContext(PaddingContext)

    useEffect(() => {
        const animationHeight =
      (document.body.clientWidth * technologyP2Animation.h) / technologyP2Animation.w
        setContentMargin(animationHeight / (isMobile ? 3 : 5))
    }, [isMobile])

    useEffect(() => {
        if (lottieRef.current) {
            setTimeout(() => lottieRef.current?.play(), 400)
        }
    }, [lottieRef])

    const unsetPlay = () => {
        if (
            animationStartRef.current &&
      document.body.scrollTop + window.innerHeight <=
        animationStartRef.current.getBoundingClientRect().top
        ) {
            setPlay(false)
        }
    }

    useEffect(() => {
        const calculatePadding = () => {
            requestAnimationFrame(() => {
                if (titleRef.current && descriptionRef.current && contentRef.current && !isMobile) {
                    const pad = {
                        paddingLeft:
              titleRef.current.getBoundingClientRect().left -
              contentRef.current.getBoundingClientRect().left,
                        paddingRight:
              window.innerWidth -
              descriptionRef.current.getBoundingClientRect().right -
              contentRef.current.getBoundingClientRect().left,
                    }
                    setPadding(pad)
                } else {
                    setPadding()
                }
            })
        }
        calculatePadding()
        window.addEventListener('resize', calculatePadding)
        return () => {
            window.removeEventListener('resize', calculatePadding)
        }
    }, [titleRef, descriptionRef, isMobile, contentRef])

    return (
        <div className='bg-white pt-12 md:pt-30 relative 3xl:max-w-screen-2xl mx-auto'>
            <div ref={contentRef} className=''>
                <SectionWithTag tag={{ id: 'section.howItWorks' }} className='pb-20'>
                    <FadeIn>
                        <div className='flex md:flex-row flex-col md:items-center py-9 md:p-0 gap-y-5 justify-between'>
                            <div className='md:w-1/2 flex justify-center'>
                                <div className='max-w-[520px]' ref={titleRef}>
                                    <FormattedMessage id='page.technology.synthesis' tagName='h2' />
                                </div>
                            </div>
                            <div className='md:w-1/2 flex justify-end'>
                                <div className='md:max-w-[410px]' ref={descriptionRef}>
                                    {' '}
                                    <FormattedMessage id='page.technology.synthesis.description'>
                                        {(value) => <p className='tracking-normal'>{value}</p>}
                                    </FormattedMessage>
                                </div>
                            </div>
                        </div>
                    </FadeIn>
                </SectionWithTag>
            </div>
            <Waypoint onEnter={() => setPlay(true)} onLeave={unsetPlay}>
                <div className='overflow-hidden w-full relative' ref={animationStartRef}>
                    <div className='content-padding md:hidden'>
                        {play && <Lottie animationData={technologyMobileAnimation} loop={false} />}
                    </div>
                    <div className='hidden md:block' style={{ ...padding }}>
                        {play && <Lottie animationData={technologyP1Animation} loop={false} />}
                    </div>
                    <div className='w-[200vw] -left-1/2 md:left-0 md:w-full absolute'>
                        {play && (
                            <div ref={ref}>
                                <Lottie animationData={technologyP2Animation} loop={false} />
                            </div>
                        )}
                    </div>
                    <Segments contentMargin={contentMargin} padding={padding} />
                </div>
            </Waypoint>
        </div>
    )
}

export default HowItWorks
